import {
  PageSectionProps,
  DefaultPageSection,
} from "@components/layout/PageSection";
import { css } from "@emotion/react";
import React from "react";

import { spacing } from "@every.org/common/src/display/spacing";

import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { compositionTextCss } from "src/theme/text";

export const ArticlePageContent: React.FCC<
  Omit<PageSectionProps, "withElement">
> = ({ contentCss, ...rest }) => {
  return (
    <DefaultPageSection
      {...rest}
      css={cssForMediaSize({
        max: MediaSize.MEDIUM_SMALL,
        css: css`
          padding: 0 ${spacing.s};
        `,
      })}
      contentCss={
        Array.isArray(contentCss)
          ? [compositionTextCss, ...contentCss]
          : [compositionTextCss, contentCss]
      }
      withElement="article"
    />
  );
};
